module.exports = __webpack_public_path__ + "img/202412_basic_01.cc70b9d0.jpg";